import { Available } from "../gateway/Available/Available";
import { Company } from "../gateway/Company/Company";
import { CompressedJsonAdapter } from "../presentation/adpters/CompressedJsonAdapter/CompressedJsonAdapter";

export class AvailablePopulateUsecase {
    constructor() {
        this.AvailableGateway = new Available();
        this.CompanyGateway = new Company();
    }

    async execute({ companyId, groupId, groupStartDate } = {}) {
        const payload = this.sanitizeInput({
            companyId,
            groupId,
            groupStartDate
        });
        if (!payload.companyId) return false;
        const hasIntegrationFinancial = await this.hasIntegrationFinancial(
            payload
        );
        const response = await this.AvailableGateway.getDates({
            companyIds: payload.companyId,
            options: {
                compress: true,
                mergeResults: payload.groupId ? true : false
            }
        });
        const restored = new CompressedJsonAdapter().decompress(response);
        const available = this.formatTimezones(restored);
        const slicedAvailable = this.sliceAvailableIfNeeded({
            available,
            groupId: payload.groupId,
            groupStartDate: payload.groupStartDate
        });
        this.AvailableGateway.deleteMany({
            companyId: {
                $eq: payload.groupId ? payload.groupId : payload.companyId
            }
        });
        const hasResponse = restored?.length > 0;
        if (hasResponse)
            this.createMany({
                data: slicedAvailable,
                hasIntegrationFinancial,
                groupId: payload.groupId
            });
        return hasResponse ? true : false;
    }

    sanitizeInput({ companyId, groupId, groupStartDate } = {}) {
        const sanitizedGroupId =
            groupId === null || groupId === undefined
                ? null
                : String(groupId).trim();
        const sanitizedGroupStartDate =
            groupStartDate === null || groupStartDate === undefined
                ? null
                : String(groupStartDate).trim();
        return {
            companyId,
            groupId: sanitizedGroupId || null,
            groupStartDate: sanitizedGroupStartDate || null
        };
    }

    async hasIntegrationFinancial({ companyId, groupId } = {}) {
        if (groupId) return true;
        const companies = await this.CompanyGateway.getByIds([companyId]);
        const company = companies?.[0] || {};
        const hasContaAzul = company?.relation?.contaazul;
        const hasOrganizationId = company?.organizationId;
        const hasOmie = company?.relation?.omie;
        return Boolean(hasContaAzul || hasOrganizationId || hasOmie);
    }

    sliceAvailableIfNeeded({ available, groupId, groupStartDate } = {}) {
        if (!groupId) return available;
        if (!available) return available;
        available[0].date.ORIGINAL = this.sliceAvailable(
            available[0]?.date?.ORIGINAL || {},
            groupStartDate
        );
        return available;
    }

    sliceAvailable(available, startDate) {
        if (!available) return available;
        const newAvailable = {};
        const _available = angular.copy(available);
        const sources = Object.keys(_available);
        if (!sources.length) return available;
        for (const source of sources) {
            const sortedAv = _available[source].sort();
            const index = sortedAv.findIndex((date) => date >= startDate);
            if (index > -1) newAvailable[source] = sortedAv.slice(index);
            if (new Date(startDate) < new Date(sortedAv[0]))
                newAvailable[source] = sortedAv;
        }
        return newAvailable;
    }

    createMany({ data = [], hasIntegrationFinancial, groupId } = {}) {
        const total = data.length;
        if (!total) return false;
        for (let i = 0; i < total; i++) {
            const rawDocument = data[i];
            const document = angular.copy(rawDocument);
            if (groupId) document.companyId = groupId;
            if (hasIntegrationFinancial) {
                const scenarios = Object.keys(document?.date || {});
                for (const scenarioName of scenarios) {
                    const hasFinancial = Object.prototype.hasOwnProperty.call(
                        document.date[scenarioName],
                        "financial"
                    );
                    if (hasFinancial) {
                        document.date[scenarioName].fin =
                            document.date[scenarioName].financial;
                        delete document.date[scenarioName].financial;
                    }
                }
            } else {
                if (document?.date?.ORIGINAL?.financial)
                    delete document.date.ORIGINAL.financial;
            }
            if (document.updatedAt)
                document.updatedAt = new Date(document.updatedAt).getTime();
            if (document.createdAt)
                document.createdAt = new Date(document.createdAt).getTime();
            this.AvailableGateway.create(document);
        }
        return true;
    }

    formatTimezones(available) {
        const _available = angular.copy(available);
        if (!_available?.length) return _available;
        const scenarioIds = Object.keys(_available[0].date);
        if (!scenarioIds.length) return available;
        const sources = ["accounting", "financial"];
        scenarioIds.forEach((scenarioId) => {
            sources.forEach((source) => {
                if (!_available[0]?.date?.[scenarioId]?.[source]) return;
                _available[0].date[scenarioId][source].forEach((d, i, arr) => {
                    arr[i] = d.replace("T02", "T00").replace("T03", "T00");
                });
            });
        });
        return _available;
    }
}
